<div mat-dialog-content>
    <div class="docLoadD-container-button close">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-documentLoad (closeDialog)="onClose()" [docLoadformId]="docLoadformId"></app-documentLoad>
</div>